import React, { useState, useEffect } from 'react';
import { Modal, Select, Input, Tabs, Button } from 'antd';

const { Option } = Select;
const { TabPane } = Tabs;

const TaxAssistantModal = ({ visible, onCancel, onOk, installmentsOptions }) => {
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [filteredInstallmentsOptions, setFilteredInstallmentsOptions] = useState([]);
  const [selectedInstallments, setSelectedInstallments] = useState(null);
  const [selectedReceiver, setSelectedReceiver] = useState(null);
  const [inputTax, setInputTax] = useState(null);
  const [activeTab, setActiveTab] = useState('1')

  const validateInputTax = value => {
    let newValue = parseFloat(value.replace(',', '.'));
    if (isNaN(newValue)) newValue = 0;
    setInputTax(newValue);
  }

  useEffect(() => {
    if (selectedPaymentType === 'debit') {
      setFilteredInstallmentsOptions(['1']);
    } else {
      setFilteredInstallmentsOptions(installmentsOptions);
    }
    setSelectedInstallments(null); // Reset installments when payment type changes
  }, [selectedPaymentType, installmentsOptions]);

  const handleOk = () => {
    if(activeTab === '1') { // mass edit
      onOk(selectedPaymentType, selectedInstallments, selectedReceiver, inputTax);
    } else if(activeTab === '2') { // final tax
      onOk(selectedPaymentType, selectedInstallments, selectedReceiver, inputTax, true);
    }
  };

  const onChange = (key) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: '1',
      label: 'Edição em massa',
      children: (
        <>
          <Select
            placeholder="Selecione o tipo"
            onChange={(value) => setSelectedPaymentType(value)}
            style={{ width: '100%', marginBottom: '10px' }}
          >
            <Option value="credit">Crédito</Option>
            <Option value="debit">Débito</Option>
          </Select>
          <Select
            placeholder="Selecione as parcelas"
            onChange={(value) => setSelectedInstallments(value)}
            value={selectedInstallments}
            style={{ width: '100%', marginBottom: '10px' }}
            disabled={!selectedPaymentType}
          >
            {filteredInstallmentsOptions.map((installment) => (
              <Option key={installment} value={installment}>
                {installment}x
              </Option>
            ))}
            <Option key="all" value="all">
              Todas
            </Option>
          </Select>
          <Select
            placeholder="Selecione o recebedor"
            onChange={(value) => setSelectedReceiver(value)}
            style={{ width: '100%', marginBottom: '10px' }}
          >
            <Option value="Administrador">Administrador</Option>
            <Option value="Agente">Agente</Option>
            <Option value="Distribuidor N1">Distribuidor N1</Option>
            <Option value="Distribuidor N2">Distribuidor N2</Option>
            <Option value="Programador">Programador</Option>
          </Select>
          <Input
            placeholder="Taxa"
            value={inputTax}
            onBlur={(value) => validateInputTax(value.target.value)}
            onChange={(value) => setInputTax(value.target.value)}
            style={{ width: '100%' }}
          />
        </>
      ),
    },
    {
      key: '2',
      label: 'Taxa Final',
      children: (
        <div>
          <Select
            placeholder="Selecione o tipo"
            onChange={(value) => setSelectedPaymentType(value)}
            style={{ width: '100%', marginBottom: '10px' }}
          >
            <Option value="credit">Crédito</Option>
            <Option value="debit">Débito</Option>
          </Select>
          <Select
            placeholder="Selecione as parcelas"
            onChange={(value) => setSelectedInstallments(value)}
            value={selectedInstallments}
            style={{ width: '100%', marginBottom: '10px' }}
            disabled={!selectedPaymentType}
          >
            {filteredInstallmentsOptions.map((installment) => (
              <Option key={installment} value={installment}>
                {installment}x
              </Option>
            ))}
            <Option key="all" value="all">
              Todas
            </Option>
          </Select>
          <Select
            placeholder="Selecione o recebedor"
            onChange={(value) => setSelectedReceiver(value)}
            style={{ width: '100%', marginBottom: '10px' }}
          >
            <Option value="Administrador">Administrador</Option>
            <Option value="Agente">Agente</Option>
            <Option value="Distribuidor N1">Distribuidor N1</Option>
            <Option value="Distribuidor N2">Distribuidor N2</Option>
            <Option value="Programador">Programador</Option>
          </Select>
          <Input
            placeholder="Taxa Final"
            value={inputTax}
            onBlur={(value) => validateInputTax(value.target.value)}
            onChange={(value) => setInputTax(value.target.value)}
            style={{ width: '100%', marginBottom: '10px' }}
          />
        </div>
      ),
    },
  ];

  return (
    <Modal
      title="Assistente de taxas"
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </Modal>
  );
};

export default TaxAssistantModal;
